export default function Skeleton({ size, content, classes }) {
    return (
        <div className={`animate-pulse ${classes}`}>
            {[...Array(size)].map((_, index) => (
                { ...content, key: index}
            ))}
        </div>
    )
}